import request from '@/utils/request'
import { handlerGetUrlParams } from '@/utils/dealUrlParams.js'

// 获取金融服务信息
export function getFinanceInfo() {
  return request({
    url: '/bus/financial/list',
    method: 'GET'
  })
}

// 获取统计数量
export function getTotalCounts() {
  return request({
    url: '/bus/thirdService/count',
    method: 'GET'
  })
}

//获取前台服务机构列表
export function getThirdServiceGetPic() {
  return request({
    url: '/bus/thirdService/getPic',
    method: 'GET'
  })
}

// 筛选金融服务信息
export function filterFinanceInfo(params) {
  const url = handlerGetUrlParams('/bus/financial/list', params)
  return request({
    url,
    method: 'GET'
  })
}

// 新增金融服务信息
export function addFinanceInfo(data) {
  return request({
    url: '/bus/financial/add',
    method: 'POST',
    data
  })
}

// 删除金融服务信息
export function deleteFinanceInfo(id) {
  return request({
    url: `/bus/financial/${id}`,
    method: 'DELETE'
  })
}

// 发布金融服务信息
export function issueFinanceInfo(data) {
  return request({
    url: '/bus/financial/publish',
    method: 'PUT',
    data
  })
}

export function editFinanceInfo(data) {
  return request({
    url: '/bus/financial/edit',
    method: 'PUT',
    data
  })
}

// 获取某id的金融服务信息
export function onceFinanceInfo(id) {
  return request({
    url: `/bus/financial/${id}`,
    method: 'GET'
  })
}

// 下架金融服务信息
export function downFinanceInfo(data) {
  return request({
    url: '/bus/financial/drop',
    method: 'PUT',
    data
  })
}

// 前台获取第三方服务信息
export function receServerInfo(param, data) {
  const url = handlerGetUrlParams('/bus/thirdService/publishlist', param)
  return request({
    url,
    method: 'POST',
    data
  })
}

// id获取前台第三方服务详细信息
export function receDetailServerInfo(id) {
  return request({
    url: `/bus/thirdService/publicInfo/${id}`,
    method: 'GET'
  })
}

// 获取第三方服务信息
export function getServerInfo(param) {
  const url = handlerGetUrlParams('/bus/thirdService/list', param)
  return request({
    url,
    method: 'GET'
  })
}

// 新增第三方服务
export function addServerInfo(data) {
  return request({
    url: '/bus/thirdService/add',
    method: 'POST',
    data
  })
}

export function serverInfoDetail(id) {
  return request({
    url: `/bus/thirdService/${id}`,
    method: 'GET'
  })
}

export function serverInfoUpdate(data) {
  return request({
    url: '/bus/thirdService/update',
    method: 'PUT',
    data
  })
}

// 删除第三方服务信息
export function deleteServerInfo(id) {
  return request({
    url: `/bus/thirdService/${id}`,
    method: 'DELETE'
  })
}

// 审批运营信息
export function statusServerInfo(data) {
  return request({
    url: '/bus/contents/thirdservice/audit',
    method: 'PUT',
    data
  })
}

// 发布第三方服务信息
export function issueServerInfo(data) {
  return request({
    url: '/bus/thirdService/publish',
    method: 'PUT',
    data
  })
}

// 下架第三方服务信息
export function downServerInfo(data) {
  return request({
    url: '/bus/thirdService/drop',
    method: 'PUT',
    data
  })
}

// 前台获取第三方服务信息浏览量
export function viewServerInfo(id) {
  return request({
    url: `/bus/thirdService/is_view/${id}`,
    method: 'PUT'
  })
}
